module.exports = {"Telephone":"Telephone","Password":"Password","Tariff":"Tariff","Registration":"Registration","English":"English","Russian":"Russian"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 1